<div id="enter-channel-name-container">
  <div
    class="x-sign"
    inlineSVG="/assets/icons/x-close-pop.svg"
    (click)="channelNameCreated.emit()"
  ></div>
  <form #channelNameForm="ngForm" (ngSubmit)="onSubmitForm(channelNameForm)">
    <label for="channelName">New Channel Name:</label>
    <input
      [(ngModel)]="channelName"
      name="channelName"
      type="text"
      required
      minlength="1"
      maxlength="100"
    />

    <button type="submit" class="save-btn">Create Channel</button>
  </form>
</div>
